import React, { useEffect, useState } from "react";
import axios from "axios";
import { PowerBIEmbed } from "powerbi-client-react";
import { models, powerbi } from "powerbi-client";
import logo from '../../../assets/img/loader4.gif'
const ReportDashboard = ({reportid,reportnameFetch}) => {
  const [powerbiReport, setPowerbiReport] = useState({});
  const [loading, setLoading] = useState(true);
  const [powerbiLoading, setpowerbiLoading] = useState(true);
  const [Pages, setPages] = useState([]);



  const powerbiReportData = async () => {
    try {
      const baseurl = `https://aays-cfo-dev-be-py.azurewebsites.net/cfo/report?reportId=${reportid}`;

      const response = await axios.get(baseurl);

      // Handling the response
      if (response.status === 200) {
        console.log("token generated successfully:", response.data);
        setLoading(false);
        setPowerbiReport(response.data);
        return response.data;
      } else {
        console.error(
          "Error posting FAQ data:",
          response.status,
          response.statusText
        );
        setLoading(false);
      }
    } catch (error) {
      console.error("Error posting FAQ data:", error);
      setLoading(false);
    }
  };

  useEffect(() => {
    powerbiReportData();
  }, []);

  // const embdData = (embeddedReport) => {
  //   window.report = embeddedReport;
  //   window.report.on("loaded", async function () {
  //     var reportPages = await window.report.getPages();
  //     console.log(reportPages)
  //   });
  // };
  const report = window.report;

  const embdData = (embeddedReport) => {
    console.log("loaded")
    // console.log("loaded",embeddedReport)

    // window.report = embeddedReport;


    // window.report.on("loaded", async function () {
    //   var reportPages = await window.report.getPages();
    //   // Function to apply filters
    //   const activePageIndex = reportPages.findIndex((page) => page.isActive);
    //   console.log(activePageIndex)

    // //   report.getPages().then((pages) => {
    // //     const indexNumber = pages.findIndex(
    // //       (p) => p.name === `${pagename}`
    // //     );
    // //     const firstPage = pages[indexNumber === -1 ? 0 : indexNumber];
    // //     const pageName = firstPage.name;
    // //     const displayName = firstPage.displayName;
    // //     setPageName(pageName);
    // //     setDisplyName(displayName);
    // //   });
    // //   let pageName = "";

    
   
    
     
    // //   const activePageIndex = reportPages.findIndex((page) => page.isActive);

    // //  console.log(activePageIndex)
     

    // //   window.report.getPages().then(function (pages) {
    // //     const visiblePages = pages.filter((page) => page.visibility === 0);
    // //     console.log(visiblePages)
      
    // //     const indexNumber = visiblePages.findIndex(
    // //       (p) => p.name === `${reportnameFetch}`
    // //     );
    
    // //     if (reportnameFetch !== null && indexNumber >= 0) {
    // //         // If the `reportnameFetch` matches, set the current page
    // //         setcurrentPage(indexNumber + 1);
    
    // //         // Remove 'active' class from all page buttons
    // //         const pageButtons = document.querySelectorAll("#pbiPages span");
    // //         pageButtons.forEach((button) => {
    // //             button.classList.remove("active");
    // //         });
    
    // //         // Add 'active' class to the page button corresponding to the index
    // //         const activeButton = document.querySelector(`#pbiPages span:nth-child(${indexNumber + 1})`);
    // //         if (activeButton) {
    // //             activeButton.classList.add("active");
    // //         }
    // //     } 
    // //     else if (visiblePages.length > 0) {
    // //         // If no `reportnameFetch` found, activate the first page with visibility 0
    // //         const firstVisiblePage = visiblePages[0];
    // //         const activePageIndex = pages.indexOf(firstVisiblePage);    
    // //         // Set the active page
    // //         pages[activePageIndex].setActive();
    
    // //         // Remove 'active' class from all page buttons
    // //         const pageButtons = document.querySelectorAll("#pbiPages span");
    // //         pageButtons.forEach((button) => {
    // //             button.classList.remove("active");
    // //         });
    
    // //         // Add 'active' class to the first page button
    // //         const activeButton = document.querySelector(`#pbiPages span:nth-child(${activePageIndex === 0 ? 1 : activePageIndex})`);
    // //         if (activeButton) {
    // //             activeButton.classList.add("active");
    // //         }
    // //     }
    // // });
    
    // //   setPages(reportPages);
    // });
  };

//   const handleReportLoaded = async (embed) => {
//     try {
//         console.log("Report loaded", embed);

//         // Fetching pages from the report
//         const reportPages = await embed.getPages();
//         // console.log("All Report Pages:", reportPages);

//         // Filtering pages based on visibility
//         const visiblePages = reportPages.filter((page) => page.visibility === 0);
        

//         setPages(visiblePages || []);    
        
//         report.on("loaded", async function () {
//           var reportPages = await report.getPages();
//           // Function to apply filters
//           const activePageIndex = reportPages.findIndex((page) => page.isActive);
//           console.log(activePageIndex)
    
//         //   report.getPages().then((pages) => {
//         //     const indexNumber = pages.findIndex(
//         //       (p) => p.name === `${pagename}`
//         //     );
//         //     const firstPage = pages[indexNumber === -1 ? 0 : indexNumber];
//         //     const pageName = firstPage.name;
//         //     const displayName = firstPage.displayName;
//         //     setPageName(pageName);
//         //     setDisplyName(displayName);
//         //   });
//         //   let pageName = "";
    
        
       
        
         
//         //   const activePageIndex = reportPages.findIndex((page) => page.isActive);
    
//         //  console.log(activePageIndex)
         
    
//         //   window.report.getPages().then(function (pages) {
//         //     const visiblePages = pages.filter((page) => page.visibility === 0);
//         //     console.log(visiblePages)
          
//         //     const indexNumber = visiblePages.findIndex(
//         //       (p) => p.name === `${reportnameFetch}`
//         //     );
        
//         //     if (reportnameFetch !== null && indexNumber >= 0) {
//         //         // If the `reportnameFetch` matches, set the current page
//         //         setcurrentPage(indexNumber + 1);
        
//         //         // Remove 'active' class from all page buttons
//         //         const pageButtons = document.querySelectorAll("#pbiPages span");
//         //         pageButtons.forEach((button) => {
//         //             button.classList.remove("active");
//         //         });
        
//         //         // Add 'active' class to the page button corresponding to the index
//         //         const activeButton = document.querySelector(`#pbiPages span:nth-child(${indexNumber + 1})`);
//         //         if (activeButton) {
//         //             activeButton.classList.add("active");
//         //         }
//         //     } 
//         //     else if (visiblePages.length > 0) {
//         //         // If no `reportnameFetch` found, activate the first page with visibility 0
//         //         const firstVisiblePage = visiblePages[0];
//         //         const activePageIndex = pages.indexOf(firstVisiblePage);    
//         //         // Set the active page
//         //         pages[activePageIndex].setActive();
        
//         //         // Remove 'active' class from all page buttons
//         //         const pageButtons = document.querySelectorAll("#pbiPages span");
//         //         pageButtons.forEach((button) => {
//         //             button.classList.remove("active");
//         //         });
        
//         //         // Add 'active' class to the first page button
//         //         const activeButton = document.querySelector(`#pbiPages span:nth-child(${activePageIndex === 0 ? 1 : activePageIndex})`);
//         //         if (activeButton) {
//         //             activeButton.classList.add("active");
//         //         }
//         //     }
//         // });
        
//         //   setPages(reportPages);
//         });


//     } catch (error) {
//         console.error("Error loading report or fetching pages:", error);
//     }
// };

  const token = powerbiReport.embedToken;
  const url = powerbiReport.reportURL;
  const reportGId = powerbiReport.reportGuid;
  const activeCurrentPage = async (e,index) => {
    // var reportPages = await window.report.getPages();
    //         reportPages[currentPage].setActive();
    var target = e.target;
    var parent = target.parentNode;
    // var index = [].indexOf.call(parent.children, target);
    // $(this).addClass("active").siblings().removeClass("active");
    console.log(index)
    console.log(parent)
    console.log(target)

    var reportPages = await window.report.getPages();
    var visibility =
      reportPages && reportPages.filter((page) => page.visibility === 0);
    // Function to apply filters
    reportPages = visibility;
    reportPages[index].setActive();
  };
  return (
    <div>
      <div style={{ height: "100vh" }}>
        {powerbiLoading && (
          <div
            style={{
              position: "absolute",
              background: "#ffffff",
              height: "100%",
              left: "0",
              right: "0",
              top: "0",
              bottom: "0",
              overflow: "hidden",
              borderRadius:"10px"
            }}
          >
            <div
              style={{
                display: "grid",
                justifyContent: "center",
                alignContent: "center",
                alignItems: "center",
                height: "100%",
                overflow: "hidden",
                gap: "1rem",
              }}
            >
              <img src={logo} alt="logo" width={100}/>

              <span style={{color:"white"}}>Please wait...</span>
            </div>
          </div>
        )}

        {!loading && (
          <div style={{display:"grid",height:"100%",gridTemplateColumns:"1fr",width:"100%",gap:"10px"}}>
                {/* <div  id="pbiPages">
                  {Pages && Pages.map((item,index)=> {
                    return(
                      <div key={index} onClick={(e)=>activeCurrentPage(e,index)}>
                          <span style={{padding:"10px",display:"block",background:"#eee"}}>{item.displayName}</span>
                      </div>
                    )
                  })}
                </div> */}
                <div>
                <PowerBIEmbed
              embedConfig={{
                type: "report", // Supported types: report, dashboard, tile, visual, qna, paginated report and create
                id: reportGId,
                embedUrl: url,
                accessToken: token,
                pageName:`${reportnameFetch}`,
                tokenType: models.TokenType.Embed, // Use models.TokenType.Aad for SaaS embed
            
                settings: {
                  // navContentPaneEnabled:false,
                  panes: {
                    filters: {
                      expanded: false,
                      visible: false,
                    },

                  },
                  background: models.BackgroundType.Transparent,
                },
              }}
              eventHandlers={
                new Map([
                  [
                    "loaded",
                    async function  (event) {
                      console.log("Report loaded");
                      setpowerbiLoading(false);
                      // var reportPages = await window.report.getPages();
                      // console.log(reportPages)
                      // console.log("Report loaded", event.target.powerBiEmbed);
                      // const embed = event.target.powerBiEmbed;
                      // await handleReportLoaded(embed);
                      // const visiblePages = reportPages.filter((page) => page.visibility === 0);
                      // setPages(visiblePages)

                      // console.log(visiblePages)
                    
                      // const indexNumber = visiblePages.findIndex(
                      //   (p) => p.name === `${reportnameFetch}`
                      // );
                  
                      // if (reportnameFetch !== null && indexNumber >= 0) {
                      //     // If the `reportnameFetch` matches, set the current page
                  
                      //     // Remove 'active' class from all page buttons
                      //     const pageButtons = document.querySelectorAll("#pbiPages span");
                      //     pageButtons.forEach((button) => {
                      //         button.classList.remove("active");
                      //     });
                  
                      //     // Add 'active' class to the page button corresponding to the index
                      //     const activeButton = document.querySelector(`#pbiPages span:nth-child(${indexNumber + 1})`);
                      //     if (activeButton) {
                      //         activeButton.classList.add("active");
                      //     }
                      // } 
                      // else if (visiblePages.length > 0) {
                      //     // If no `reportnameFetch` found, activate the first page with visibility 0
                      //     const firstVisiblePage = visiblePages[0];
                      //     const activePageIndex = reportPages.indexOf(firstVisiblePage);    
                      //     // Set the active page
                      //     reportPages[activePageIndex].setActive();
                  
                      //     // Remove 'active' class from all page buttons
                      //     const pageButtons = document.querySelectorAll("#pbiPages span");
                      //     pageButtons.forEach((button) => {
                      //         button.classList.remove("active");
                      //     });
                  
                      //     // Add 'active' class to the first page button
                      //     const activeButton = document.querySelector(`#pbiPages span:nth-child(${activePageIndex === 0 ? 1 : activePageIndex})`);
                      //     if (activeButton) {
                      //         activeButton.classList.add("active");
                      //     }
                      // }
                    },
                  ],
                  [
                    "rendered",
                    function () {
                      console.log("Report rendered");
                    },
                  ],
                  [
                    "error",
                    function (event) {
                      console.log(event.detail);
                    },
                  ],
                  ["visualClicked", () => console.log("visual clicked")],
                  ["pageChanged", (event) => console.log(event)],
                ])
              }
              cssClassName={"report-style-class"}
              getEmbeddedComponent={embdData}
            />
                </div>

           
          </div>
        )}
      </div>
    </div>
  );
};

export default ReportDashboard;
